import React, { useState } from 'react';
import { Box, Text, Input, IconButton } from '@chakra-ui/react';
import { FiEdit3, FiCheck, FiX } from 'react-icons/fi';
import { updateCardDueDate } from '../../../../../ProjectBoardServices/BoardModalAPI/RightModalAPI/InfoTabAPI/DueDateAPI';

const DueDate = ({ task, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [dueDateValue, setDueDateValue] = useState(
    task?.dueDate ? task.dueDate.split("T")[0] : ''
  );
  const [isLoading, setIsLoading] = useState(false);

  const formatDate = (dateString) => {
    if (!dateString || dateString === '1970-01-01T00:00:00Z') return 'Not set';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    } catch {
      return 'Invalid date';
    }
  };

  const handleSave = async () => {
    if (!dueDateValue) return;

    setIsLoading(true);
    try {
      // ✅ Service function use kar rahe hain
      const response = await updateCardDueDate(task.id, dueDateValue);

      if (response.data) {
        setIsEditing(false);
        if (onUpdate) {
          onUpdate({ ...task, dueDate: dueDateValue });
        }
      }
    } catch (error) {
      console.error('Failed to update due date:', error);
      alert('Failed to update due date. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setDueDateValue(task?.dueDate ? task.dueDate.split("T")[0] : '');
    setIsEditing(false);
  };

  return (
    <Box>
      <Text fontSize="12px" fontWeight="600" color="#6B778C" mb={2} textTransform="uppercase">
        DUE DATE
      </Text>

      {isEditing ? (
        <Box display="flex" alignItems="center" gap={2}>
          <Input
            type="date"
            value={dueDateValue}
            onChange={(e) => setDueDateValue(e.target.value)}
            size="sm"
            fontSize="14px"
          />
          <IconButton
            icon={<FiCheck />}
            size="sm"
            colorScheme="green"
            onClick={handleSave}
            isLoading={isLoading}
            aria-label="Save due date"
          />
          <IconButton
            icon={<FiX />}
            size="sm"
            variant="ghost"
            onClick={handleCancel}
            aria-label="Cancel edit"
          />
        </Box>
      ) : (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Text fontSize="14px" color="#172B4D">
            {formatDate(task?.dueDate)}
          </Text>
          <IconButton
            icon={<FiEdit3 />}
            size="xs"
            variant="ghost"
            onClick={() => setIsEditing(true)}
            aria-label="Edit due date"
          />
        </Box>
      )}
    </Box>
  );
};

export default DueDate;
